import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./atlantis-preview-fixes.css";
import "./atlantis-preview-fixes-v2.css";

import "./reunion-layout-fixes.css";

createRoot(document.getElementById("root")!).render(<App />);
